import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const ExportActionBar = ({ qrCodeData, onExport }) => {
  const [loadingState, setLoadingState] = useState({
    download: false,
    copy: false,
    print: false,
  });

  const [successState, setSuccessState] = useState({
    download: false,
    copy: false,
    print: false,
  });

  const handleExport = async (type) => {
    setLoadingState(prev => ({ ...prev, [type]: true }));

    try {
      await new Promise(resolve => setTimeout(resolve, 800));

      if (onExport) {
        await onExport(type);
      }

      setLoadingState(prev => ({ ...prev, [type]: false }));
      setSuccessState(prev => ({ ...prev, [type]: true }));

      setTimeout(() => {
        setSuccessState(prev => ({ ...prev, [type]: false }));
      }, 2000);
    } catch (error) {
      setLoadingState(prev => ({ ...prev, [type]: false }));
      console.error(`Export ${type} failed:`, error);
    }
  };

  const exportActions = [
    {
      type: 'download',
      label: 'Download',
      icon: 'Download',
      variant: 'default',
      description: 'Save as PNG/SVG',
    },
    {
      type: 'copy',
      label: 'Copy',
      icon: 'Copy',
      variant: 'outline',
      description: 'Copy to clipboard',
    },
    {
      type: 'print',
      label: 'Print',
      icon: 'Printer',
      variant: 'outline',
      description: 'Print QR code',
    },
  ];

  return (
    <div className="bg-card rounded-xl border border-border p-6 lg:p-8 shadow-warm-md lg:sticky lg:top-24">
      <div className="mb-6">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-1">
          Export Your QR Code
        </h3>
        <p className="text-sm font-caption text-muted-foreground">
          Choose your preferred export format
        </p>
      </div>
      <div className="space-y-3">
        {exportActions?.map((action) => (
          <Button
            key={action?.type}
            variant={action?.variant}
            fullWidth
            loading={loadingState?.[action?.type]}
            iconName={successState?.[action?.type] ? 'Check' : action?.icon}
            iconPosition="left"
            onClick={() => handleExport(action?.type)}
            className={`
              h-14 justify-start
              ${successState?.[action?.type] ? 'bg-success text-success-foreground hover:bg-success' : ''}
            `}
          >
            <div className="flex flex-col items-start flex-1">
              <span className="font-medium">
                {successState?.[action?.type] ? 'Success!' : action?.label}
              </span>
              <span className="text-xs opacity-80 font-caption">
                {action?.description}
              </span>
            </div>
          </Button>
        ))}
      </div>
      <div className="mt-6 pt-6 border-t border-border">
        <div className="flex items-start gap-2">
          <Icon name="Info" size={16} color="var(--color-muted-foreground)" strokeWidth={2} className="mt-0.5 flex-shrink-0" />
          <p className="text-xs font-caption text-muted-foreground leading-relaxed">
            High-resolution exports maintain quality for both digital and print use. 
            Test your QR code before mass production.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExportActionBar;